import { Component, Vue, PropSync, Watch, Emit } from 'vue-property-decorator';
import { TableMenuItem } from '@/models/general/TableMenuItem';
import { TableMenuActionEnums } from '@/enums/TableMenuActionEnums';
import { TableClickEvent } from '@/models/tables/TableClickEvent';
import { TableMenuClickEvent } from '@/models/tables/TableMenuClickEvent';

@Component
export default class TableRowMenuComponent extends Vue {
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;
    @PropSync('event', { type: Object }) public syncedEvent!: TableClickEvent;
    @PropSync('delay', { type: Number }) public syncedDelay!: number;
    @PropSync('fixedRows', { type: Number }) public syncedFixedRows!: number;

    public menuItems: TableMenuItem[] = [];

    get visibleMenuItems(): TableMenuItem[] {
        return this.menuItems.filter((item) => item.hidden !== true);
    }

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.menuItems.push(new TableMenuItem({ textId: 'fixRow', icon: '$vuetify.icons.fixRow', action: TableMenuActionEnums.FIX_ROW, disabled: this.syncedFixedRows === 5 }));
        this.menuItems.push(new TableMenuItem({ textId: 'previewDataset', icon: 'mdi-magnify', action: TableMenuActionEnums.PREVIEW_DATASET }));
        this.menuItems.push(new TableMenuItem({ textId: 'editLine', icon: 'mdi-pencil', action: TableMenuActionEnums.EDIT_LINE }));
        this.menuItems.push(new TableMenuItem({ textId: 'cloneLine', icon: 'mdi-file-multiple', action: TableMenuActionEnums.CLONE_LINE }));
        this.menuItems.push(new TableMenuItem({ textId: 'deleteLine', icon: 'mdi-delete', action: TableMenuActionEnums.DELETE_LINE }));
        this.menuItems.push(new TableMenuItem({ textId: 'report', icon: '$vuetify.icons.settingsReport', action: TableMenuActionEnums.SETTINGS_REPORT }));
        this.menuItems.push(new TableMenuItem({ textId: 'exportTestExcel', icon: 'mdi-application-export', action: TableMenuActionEnums.EXPORT_TEST_SERIES_EXCEL }));
        this.menuItems.push(new TableMenuItem({ textId: 'copyTabId', icon: 'mdi-content-copy', action: TableMenuActionEnums.COPY_TAB_ID }));
        this.menuItems.push(new TableMenuItem({ textId: 'copyTabIdUrl', icon: 'mdi-content-copy', action: TableMenuActionEnums.COPY_TAB_ID_URL }));
        this.updateOwnerActions(this.syncedEvent && this.syncedEvent.isOwner === true);
    }

    @Watch('syncedEvent', { deep: true })
    public onSyncedEventChanged(newValue: TableClickEvent) {
        this.changeFixRow(newValue.isFixed);
        this.updateOwnerActions(newValue.isOwner === true);
    }

    @Emit()
    public itemClicked(menuAction: TableMenuActionEnums): TableMenuClickEvent {
        return new TableMenuClickEvent({ dataSetId: this.syncedEvent.dataSetId, action: menuAction });
    }

    public onItemClicked(index: number) {
        this.syncedShow = false;
        this.itemClicked(this.visibleMenuItems[index].action);
    }

    private updateOwnerActions(isOwner: boolean) {
        this.menuItems.forEach((item) => {
            if (item.action === TableMenuActionEnums.EDIT_LINE || item.action === TableMenuActionEnums.DELETE_LINE) {
                item.hidden = !isOwner;
            }
        });
    }

    private changeFixRow(showUnfix: boolean) {
        if (showUnfix === true) {
            const menuItem = this.menuItems.find((item) => item.action === TableMenuActionEnums.FIX_ROW);
            if (menuItem !== undefined) {
                menuItem.action = TableMenuActionEnums.UNFIX_ROW;
                menuItem.textId = 'unfixRow';
                menuItem.disabled = false;
            }
        } else {
            const menuItem = this.menuItems.find((item) => item.action === TableMenuActionEnums.UNFIX_ROW);
            if (menuItem !== undefined) {
                menuItem.action = TableMenuActionEnums.FIX_ROW;
                menuItem.textId = 'fixRow';
                menuItem.disabled = this.syncedFixedRows === 5;
            } else {
                const menuItem2 = this.menuItems.find((item) => item.action === TableMenuActionEnums.FIX_ROW);
                if (menuItem2 !== undefined) {
                    menuItem2.disabled = this.syncedFixedRows === 5;
                }
            }
        }
    }
}
